/* Built In Imports */
import dynamic from 'next/dynamic';
import { useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Delayed from '@components/UI/Common/Delayed';
import FormReport from './FormReport';
// import PdfViewerComponent from './Pdf';

const PdfViewerComponent = dynamic(() => import('./Pdf'), {
  ssr: false
});

/**
 * @param {string} id - Report Id
 * @returns {ReactElement} ReportView component
 */
const ReportView = ({ id }) => {
  const [pdf, setPdf] = useState('');
  const [error, setError] = useState();

  // this will be main
  return pdf ? (
    <Delayed waitBeforeShow="20000" waitMsg="Loading Report...">
      <PdfViewerComponent url={pdf} />
    </Delayed>
  ) : (
    <Box>
      <FormReport setPdf={setPdf} setError={setError} id={id} />
      {error ? error : null}
    </Box>
  );

  // return (
  //   <Box>
  //     <FormReport setPdf={setPdf} setError={setError} id={id} />
  //     {error ? error : null}
  //   </Box>
  // );

  //testing pdf here
  // return <></>;
  // return (
  //   <PdfViewerComponent url={`/assets/A-Catechism-of-Enlightenment.pdf`} />
  // );
};

export default ReportView;
